import { Fragment } from "react/jsx-runtime";
import { CSS } from "src/_utils/styles";
import { Breadcrumbs } from "src/AbstractElements";
import DefaultContain from "src/Component/DashBoard/Default";
import { useEBSSS } from "./context/EBSSSContext/useEBSSS";
import { getQueryParams } from "src/_utils/urls";
import { useDispatch, useSelector } from "react-redux";
import { clearCartAndOrderSessionSimple, Session } from "./store/authSlice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EBSSSChatContainer from "./atoms/EBSSSChatContainer";
import { RenderReactChatInstance } from "src/assets/chat/chat";
import { EBSSSChatModule } from "src/assets/chat/core";
import { ReduxDataKey } from "./store/store";

const Page = ({
  children,
  breads,
  hideTitle,
  hideBreadcrumbs,
  isCMS,
}: {
  children: any;
  breads: any;
  hideTitle?: boolean;
  hideBreadcrumbs?: boolean;
  isCMS?: boolean;
}) => {
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const { loaded, hasChats, chatDataPreview, chatDataSetter, setHasChats, setChatDataPreview, setChatDataSetter } = useEBSSS();
  const dispatcher = useDispatch();
  const navigate = useNavigate();
  const exceptLoaderOnRoutes = ["v2/crm/products", "v2/crm/seller", "v2/crm/contacts/center/"];

  useEffect(() => {
    const getQueryParamsSettings = getQueryParams(window.location.href);
    if (getQueryParamsSettings?.resetCart) {
      dispatcher(clearCartAndOrderSessionSimple());
      navigate(process.env.PUBLIC_URL + "/crm/products?page=1", {
        replace: true,
      });
    }
  }, []);

  useEffect(() => {
    if (!isCMS) {
      let dettachCMSTemplate = Array.from(document.querySelectorAll('[cms="true"], [href*="cms=true"], [src*="cms=true"]'));
      console.log("dettachCMSTemplate: ", dettachCMSTemplate);
      dettachCMSTemplate.forEach((el) => el.remove());
    }
    return () => {
      if (!isCMS) {
        let dettachCMSTemplate = Array.from(document.querySelectorAll('[cms="true"], [href*="cms=true"], [src*="cms=true"]'));
        console.log("dettachCMSTemplate: ", dettachCMSTemplate);
        dettachCMSTemplate.forEach((el) => el.remove());
      }
    };
  }, []);

  console.log("Has chats Page element: ", hasChats);

  return (
    <Fragment>
      {!isCMS ? (
        hideTitle && hideBreadcrumbs ? (
          <></>
        ) : sessionNow?.user["from_gamify"] ? (
          <></>
        ) : (
          <Breadcrumbs hideTitle={hideTitle} hideBreadcrumbs={hideBreadcrumbs} breads={breads} title={!hideBreadcrumbs ? breads[breads.length - 1].name : ""} />
        )
      ) : (
        <></>
      )}
      <DefaultContain>
        {exceptLoaderOnRoutes.some((expt) => window.location.pathname.includes(expt)) ? (
          children
        ) : loaded ? (
          children
        ) : (
          <div className="w-100 justify-center justify-content-center d-flex no-print-ebsss" style={CSS({ height: "50vh" })}>
            <div className="loader d-flex align-center justify-center m-auto text-center">
              <div className="loader-bar"></div>
              <div className="loader-bar"></div>
              <div className="loader-bar"></div>
              <div className="loader-bar"></div>
              <div className="loader-bar"></div>
              <div className="loader-ball"></div>
            </div>
          </div>
        )}
        {hasChats?.length > 0 ? (
          hasChats?.map((ch) => {
            console.log("Guid config: ", ch);
            if (ch.type !== "pop") return <></>;
            if (localStorage.getItem("NOT_FOUND_CHAT_" + ch.guid) === "true") return <></>;
            //@ts-ignore
            new EBSSSChatModule(ch).init();
            return (
              <EBSSSChatContainer chatDataSetter={chatDataSetter} guidData={ch} chatDataPreview={chatDataPreview}>
                <RenderReactChatInstance
                  {...(ch as any)}
                  sufixGUID={ch.guid}
                  chatDataSetter={chatDataSetter}
                  setChatDataSetter={setChatDataSetter}
                  setChatDataPreview={setChatDataPreview}
                />
              </EBSSSChatContainer>
            );
          })
        ) : (
          <></>
        )}
      </DefaultContain>
    </Fragment>
  );
};
export default Page;
